<template>
  <div id="homepage" :class="(item.sticker != '' && item.is_hompage_in_sidebar == 0 ? 'has_sticker' : '')">
      <!--<img :src="(is_mobile() ? item.pic_front_tumb : item.pic_cover_tumb)" alt="" class="home-feature-image mCS_img_loaded"> -->
      <div class="pic" :style="'background-image:url(' + (is_mobile() && item.pic_front_tumb ? item.pic_front_tumb : item.pic_cover_tumb) + ')'"></div>
      <div v-if="item.sticker != '' && item.is_hompage_in_sidebar == 0" v-html="item.sticker" class="sticker_text"></div>
     
  </div>
</template>

<script>
export default {
  props: ["widgets", "item"],
  created(){
    
    
  }
}
</script>

<style lang="scss">
#homepage .pic { 
  
      object-fit: cover;
        max-width: 99%;
        width: auto;
        display: block;
        height: calc(100vh - 145px);
        margin: auto;
        background: center center no-repeat; background-size: contain;
@media only screen and (max-width: 700px) {
    padding-bottom: 86%;
    height: auto;
    background-position:top center; 
}
 }
 

</style>